if (!customElements.get('collection-subcategory-menu')) {
  class CollectionSubcategoryMenu extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gn-subcategory-menu__track');
      this.head = this.querySelector('.gn-subcategory-menu__head');
      this.controls = this.querySelector('.gn-subcategory-menu__controls');
      this.prev = this.querySelector('.gn-subcategory-menu__prev');
      this.next = this.querySelector('.gn-subcategory-menu__next');
      if (!this.track || !this.prev || !this.next) return;

      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onScroll = () => this.updateControls();
      this.onResize = () => this.updateControls();

      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      requestAnimationFrame(() => this.updateControls());
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    step() {
      const first = this.track.querySelector('.gn-subcategory-menu__item');
      if (!first) return this.track.clientWidth;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return first.getBoundingClientRect().width + gap;
    }

    move(direction) {
      this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
    }

    updateControls() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const left = Math.max(0, this.track.scrollLeft);
      const hasOverflow = maxScroll > 2;

      if (this.head) this.head.hidden = !hasOverflow;
      if (this.controls) this.controls.hidden = !hasOverflow;
      this.prev.disabled = !hasOverflow || left <= 2;
      this.next.disabled = !hasOverflow || left >= maxScroll - 2;
    }
  }

  customElements.define('collection-subcategory-menu', CollectionSubcategoryMenu);
}
